import { matchingEngineApi } from '../matching-engine.utils';
import { useSession, useInfiniteQuery } from 'common/hooks';
import { createCursorQueryParams, getNextCursorParam } from 'features/org-root';

export const useGetWorkItemsGroupedByQuarter = (params: { profileId: string }) => {
  const { account: user } = useSession();
  const { profileId } = params;
  const getWorkItems = (params: any) => {
    const queryParams = createCursorQueryParams(params.pageParam, {
      profileId,
    });
    return matchingEngineApi.get('work-items-grouped-by-quarter', { params: queryParams });
  };

  const queryKey = [
    'matching-engine',
    user?.organizationId,
    profileId,
    'work-items-grouped-by-quarter',
  ];

  const queryResponse = useInfiniteQuery(queryKey, getWorkItems, {
    getNextPageParam: getNextCursorParam,
    entityKey: 'workItems',
    enabled: !!profileId,
  });
  const data = queryResponse.isSuccess ? queryResponse.data.pages : [];
  return {
    ...queryResponse,
    data,
  };
};
